import { render, staticRenderFns } from "./ProductQtyRecordList.vue?vue&type=template&id=5ff754eb&scoped=true"
import script from "./ProductQtyRecordList.vue?vue&type=script&lang=js"
export * from "./ProductQtyRecordList.vue?vue&type=script&lang=js"
import style0 from "./ProductQtyRecordList.vue?vue&type=style&index=0&id=5ff754eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff754eb",
  null
  
)

export default component.exports